// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"selector_wrapper__19uzA","headingWrapper":"selector_headingWrapper__3CpMy","headingSection":"selector_headingSection__1qK-Q","arrow":"selector_arrow__3DX2g"};